<template>
    <div class="jz_getyh">
            <div class="getyhq_top" data="133"><img src="../../assets/image/getyhq_top.png"></div>
            <div class="getyhq_main">
                                   <div id="quan_main_div" :class="isfirst?'getyhq_quan':'getyhq_quan_gray'" data="133">
                    <div :class="isfirst?'quan_con':'quan_con_gray'" id="quan_main_1">
                        <p id="quan_main_2" :class="isfirst?'quan_title':'quan_title_gray'">{{voucher_info.title}}</p>
                        <p id="quan_main_3" :class="isfirst?'quan_mes':'quan_mes_gray'">满{{voucher_info.vouchertemplate_limit}}元减<span class="quan_mesbig">{{voucher_info.vouchertemplate_price}}元</span></p>
                        <p id="quan_main_4" :class="isfirst?'quan_date':'quan_date_gray'">{{voucher_info.desc}}：{{voucher_info.showtime}}</p>
                    </div>
                    <span id="quan_main_5" v-if="isfirst" class="yp_ljlq" @click="handleLQ"></span>
                    <span class="yp_ljlq_gray" v-else @click="handleLlq"></span>
                    
                   </div>
                                <div class="yq_goods" style="background: #ab221e;" data="7117">
                    <a class="yq_goods_inner" href="javascript:void(0);">
                        <img :src="goods_info.goods_image" class="yq_goods_pic">
                        <div class="yq_goods_right">
                            <p class="yp_goods_title">{{goods_info.goods_name}}</p>
                            <p class="yp_goods_comment">{{goods_info.evaluation_count}}条评论</p>
                            <p class="yp_goods_jzprice">甲子价：<span style="text-decoration: line-through;">¥{{goods_info.goods_price}}</span></p>
                            <p class="yp_goods_price">用券后：¥{{goods_info.goods_promotion_price}}</p>
                        </div>
                    </a>
                    <!--
                    <p class="yq_goods_click">点击查看商品详情</p>
                    -->
                    <div style="width: 99.9%;
    text-align: center;
    border: 1px solid #e83f34;
    line-height: 40px;
    color: white;
    background: #e83f34;
    margin-top: 10px;
    border-radius: 14px;" @click="handleBuy">{{isfirst?"点击查看":"点击购买"}}</div>
                </div>
                <div class="yq_actpro">
                    <h3 class="yq_acth3">{{activity_info.title}}</h3>
                    <div class="yq_accon">
                        <p v-for="(item,index) in activity_info.child" :key="index">
                            {{item}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>

import { vact_specify,vact_specify_receive} from '../../api/voucher'
import { mapState } from 'vuex'
import { Toast ,Indicator} from 'mint-ui'
export default {
    name:'voucher',
    data() {
        return {
           activity_info:{
               child:[]
           } , //    领劵信息
           voucher_info: {},
           goods_info:{},
           isfirst:true
        }
    },
    mounted() {
       this.initPage()
    },
    computed: mapState({
        isOnline: state => state.member.isOnline,
        token: state => state.member.token
    }),
    methods:{
        initPage() {
            let id = this.$route.query.vid || '29'
            Indicator.open()
            vact_specify(this.$route.query.vid,this.token || '',
            ).then(res => {
                Indicator.close()
                    if(res.code === 10000) {
                        this.activity_info = res.result.activity_info
                        this.activity_info.child = this.activity_info.child || []
                        this.voucher_info = res.result.voucher_info
                        this.goods_info = res.result.goods_info
                        this.isfirst = this.voucher_info.iscan_receive
                    }
            }).catch(function (error) {
                Indicator.close()
                    Toast(error.message)
                })

        },
        // 立即购买
        handleBuy() {
            this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.goods_info.goods_id } })
        },
        // 领取
        handleLQ() {
             let id = this.$route.query.vid || '29'
           vact_specify_receive(this.$route.query.vid,this.token || '',
            ).then(res => {
                Indicator.close()
                    if (res.code === 10000) {
                       Toast('领取成功自动跳转至详情')
                       setTimeout(() => {
                           this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.goods_info.goods_id } })
                       },1000)
                       this.isfirst = false
                    }
            }).catch(function (error) {
                Indicator.close()

                    Toast(error.message)
                })
        },
        handleLlq() {
            Toast('已经领取')
        }
    }
}
</script>
<style scoped>
.jz_getyh{width: 100%;margin: 0 auto;background: url(../../assets/image/getyhq_bg.png) no-repeat center top;background-size: cover; }
.jz_getyh .getyhq_top{width: 100%;position: absolute;top: 0;left: 0;right: 0;z-index: 1;}
.jz_getyh .getyhq_top img{width: 100%;}
.jz_getyh .getyhq_main{padding: 64px 10px;}
.jz_getyh .getyhq_main .getyhq_quan{max-width: 344px;background: url(../../assets/image/pic_gouwuquan_red.png) no-repeat center top;background-size: 100% 100%;
width: 100%;height: 122px;margin: 0 auto;position: relative;}
.jz_getyh .getyhq_main .getyhq_quan .yp_ljlq{width: 96px;height: 96px;position: absolute;right: -1px;top: 16px;z-index:1000;background: url(../../assets/image/btn_lijilingqu_red.png) no-repeat;
    display: inline-block;background-size: 96px 96px;}
.getyhq_main .getyhq_quan .quan_con{position: absolute;left: 0;top: 0;bottom: 0;width: 80%;text-align: left;height: 122px;color: #fff;font-size: 12px;
         padding: 10px 0;margin-left: 5px;}
.getyhq_main .getyhq_quan .quan_con .quan_title{font-size: 15px;text-align: center;}
.quan_mesbig{font-size: 44px;}

.jz_getyh .getyhq_main .getyhq_quan_gray{max-width: 344px;background: url(../../assets/image/pic_huiquan.png) no-repeat center top;background-size: 100% 100%;
width: 100%;height: 122px;margin: 0 auto;position: relative;}
.jz_getyh .getyhq_main .getyhq_quan_gray .yp_ljlq_gray{width: 96px;z-index:1000;height: 96px;position: absolute;right: -1px;top: 16px;background: url(../../assets/image/btn_lingquok.png) no-repeat;
    display: inline-block;background-size: 96px 96px;}
.getyhq_main .getyhq_quan_gray .quan_con_gray{position: absolute;left: 0;top: 0;bottom: 0;width: 80%;text-align: left;height: 122px;color: #757575;font-size: 12px;
         padding: 10px 0;margin-left: 5px;}
.getyhq_main .getyhq_quan_gray .quan_con_gray .quan_title_gray{font-size: 15px;text-align: center;}
.quan_mesbig_gray{font-size: 44px;}
.yq_goods{background: #e83f34;max-width: 344px;padding: 10px;border-radius: 3px;margin: 30px auto;}
.yq_goods_inner{background: #fff;padding: 8px;display: flex;}
.yq_goods_pic{width: 98px;height: 98px;margin-right: 5px;}
.yq_goods_right{flex:1;}
.yq_goods_right .yp_goods_title{color: #404040;font-size: 14px;width: 100%;line-height: 19px;height: 38px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;
    -webkit-line-clamp: 2;-webkit-box-orient: vertical;}
.yq_goods_right .yp_goods_comment{color: #9a9a9a;font-size: 11px;text-align: right;line-height: 18px;}
.yq_goods_right .yp_goods_jzprice{color: #9a9a9a;font-size: 11px;line-height: 20px;}
.yq_goods_right .yp_goods_price{color: #ea4a51;font-size: 14px;line-height: 22px;}
.yq_goods .yq_goods_click{color: #fff;text-align: center;margin-top: 10px;}
.yq_actpro{margin-top: 44px;text-align: center;}
.yq_actpro .yq_acth3{height: 30px;line-height: 30px;position: relative;display: inline-block;width: 200px;color: #4f4e4b;}
.yq_actpro .yq_acth3:before{content: "";width: 50px;height: 1px;background: #aeaca5; position: absolute;left: 0;top: 14px;}
.yq_actpro .yq_acth3:after{content: "";width: 50px;height: 1px;background: #aeaca5; position: absolute;right: 0;top: 14px;}
.yq_accon p{color: #9e9c95;font-size: 12px;line-height: 15px;margin-top: 10px;text-align: left;}
</style>